import { persistor } from "../../../store";
import {
  serviceBusLoggedIn,
  setLanguageThunk,
  userLoggedInThunk,
} from "../../../store/thunks";
import { decodedToken } from "../../../utils/helpers";
import { clearDeeplink } from "../../../store/persistStore";

export class LoginCommand {
  constructor(token, dispatch, navigate, path = "/", lang = "en") {
    this.token = token;
    this.dispatch = dispatch;
    this.navigate = navigate;
    this.path = path;
    this.lang = lang;
  }

  async execute() {
    localStorage.setItem("token", this.token);
    const decoded = decodedToken();
    const user = {
      token: this.token,
      email: decoded.email,
      id: decoded.id,
      refresh_token: decoded.refresh_token,
    };
    await this.dispatch(userLoggedInThunk(user));
    await this.dispatch(setLanguageThunk(this.lang, true));
    await this.dispatch(serviceBusLoggedIn());

    await persistor.flush();

    const loginRedirectPath =
      this.path &&
      this.path !== "/app" &&
      this.path !== "/signin-oidc" &&
      this.path !== "/login" &&
      this.path !== "/"
        ? `${this.path}`
        : "/progress";
    clearDeeplink();
    this.navigate.push(loginRedirectPath);
  }
}
